import { Card, Statistic, Row, Col, theme } from "antd";
import {
  CheckCircleOutlined,
  CloseCircleOutlined,
  ClockCircleOutlined,
  WarningOutlined,
  FieldTimeOutlined,
} from "@ant-design/icons";

export function AuditLogStats({ logs, totalCount }) {
  const { token } = theme.useToken();

  const stats = {
    total: logs?.total_attempts, //totalCount || logs.length,
    confirmed: logs?.success, //logs.filter((l) => l.status === "CONFIRMED").length,
    failed: logs?.failed, //logs.filter((l) => l.status === "FAILED").length,
    abandoned: logs?.abandoned, //logs.filter((l) => l.status === "ABANDONED_CHECKOUT").length,
    expired: logs?.expired, //logs.filter((l) => l.status === "EXPIRED").length,
    inProgress: logs?.partial, //logs.filter((l) => l.status === "IN_PROGRESS").length,
  };

  const statItems = [
    {
      label: "Total Attempts",
      value: stats.total,
      icon: <ClockCircleOutlined />,
      color: token.colorText,
      bgColor: token.colorBgTextHover,
    },
    {
      label: "Confirmed",
      value: stats.confirmed,
      icon: <CheckCircleOutlined />,
      color: token.colorSuccess,
      bgColor: token.colorSuccessBg,
    },
    {
      label: "Failed",
      value: stats.failed,
      icon: <CloseCircleOutlined />,
      color: token.colorError,
      bgColor: token.colorErrorBg,
    },
    {
      label: "Abandoned",
      value: stats.abandoned,
      icon: <WarningOutlined />,
      color: token.colorWarning,
      bgColor: token.colorWarningBg,
    },
    {
      label: "Expired",
      value: stats.expired,
      icon: <FieldTimeOutlined />,
      color: "#722ed1",
      bgColor: "#f9f0ff",
    },
  ];

  return (
    <Row gutter={[12, 12]}>
      {statItems.map((item) => (
        <Col xs={12} sm={12} md={4} lg={4} xl={4} key={item?.label}>
          <Card
            size="small"
            style={{
              background: item.bgColor,
              borderColor: "transparent",
            }}
          >
            <Statistic
              title={
                <span
                  style={{
                    color: item?.color || "#0000",
                    display: "flex",
                    alignItems: "center",
                    gap: 6,
                  }}
                >
                  <span className="audit-logs-icon">{item?.icon}</span>
                  <span style={{ fontSize: 12 }}>{item?.label}</span>
                </span>
              }
              value={item.value}
              valueStyle={{
                color: item?.color || "#0000",
                fontSize: 28,
                fontWeight: 600,
                justifySelf: "left",
              }}
            />
          </Card>
        </Col>
      ))}
    </Row>
  );
}
